// extracted by mini-css-extract-plugin
module.exports = {"switch":"styles_switch__9boCQ","slider":"styles_slider__3Q7Fi"};